// extracted by mini-css-extract-plugin
module.exports = {"root":"Carousel_root__4C98n","layout":"Carousel_layout__Eiivl","slider":"Carousel_slider__vfFx2","rotation":"Carousel_rotation__ECgZx"};